import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Hash, Gift } from 'lucide-react';

const IssueTokenModal = ({ isOpen, onClose, appointment, onIssueToken }) => {
  const [selectedType, setSelectedType] = useState(null);

  const handleIssue = () => {
    if (selectedType !== null) {
      onIssueToken(selectedType === 'complimentary');
    }
  };

  const handleClose = () => {
    setSelectedType(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-gray-900">Issue Token</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="text-sm text-gray-600 mb-4">
            <p className="font-semibold">{appointment?.patient_name}</p>
            <p>{appointment?.service_name}</p>
          </div>

          <div className="space-y-3">
            <p className="text-sm font-medium text-gray-700 mb-3">Select Token Type:</p>
            
            {/* Normal Token Option */}
            <button
              onClick={() => setSelectedType('normal')}
              className={`w-full p-4 border-2 rounded-xl transition-all ${
                selectedType === 'normal'
                  ? 'border-emerald-500 bg-emerald-50'
                  : 'border-gray-200 hover:border-emerald-300 hover:bg-emerald-50'
              }`}
            >
              <div className="flex items-center gap-3">
                <div className={`p-3 rounded-lg ${
                  selectedType === 'normal' ? 'bg-emerald-500' : 'bg-gray-200'
                }`}>
                  <Hash className={`w-6 h-6 ${
                    selectedType === 'normal' ? 'text-white' : 'text-gray-600'
                  }`} />
                </div>
                <div className="flex-1 text-left">
                  <p className="font-semibold text-gray-900">Normal Token</p>
                  <p className="text-sm text-gray-600">MISHA system (M1, I1, S1, H1, A1...)</p>
                </div>
                {selectedType === 'normal' && (
                  <div className="w-6 h-6 rounded-full bg-emerald-500 flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
            </button>

            {/* Complimentary Token Option */}
            <button
              onClick={() => setSelectedType('complimentary')}
              className={`w-full p-4 border-2 rounded-xl transition-all ${
                selectedType === 'complimentary'
                  ? 'border-purple-500 bg-purple-50'
                  : 'border-gray-200 hover:border-purple-300 hover:bg-purple-50'
              }`}
            >
              <div className="flex items-center gap-3">
                <div className={`p-3 rounded-lg ${
                  selectedType === 'complimentary' ? 'bg-purple-500' : 'bg-gray-200'
                }`}>
                  <Gift className={`w-6 h-6 ${
                    selectedType === 'complimentary' ? 'text-white' : 'text-gray-600'
                  }`} />
                </div>
                <div className="flex-1 text-left">
                  <p className="font-semibold text-gray-900">Complimentary Token</p>
                  <p className="text-sm text-gray-600">Special tokens (C1, C2, C3...)</p>
                </div>
                {selectedType === 'complimentary' && (
                  <div className="w-6 h-6 rounded-full bg-purple-500 flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
            </button>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <Button
            onClick={handleClose}
            variant="outline"
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handleIssue}
            disabled={!selectedType}
            className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
          >
            Issue Token
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default IssueTokenModal;
